import { instanceMrgSvc as service } from "services/serviceStorage";
import { wrapRequest } from "common/utils";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { BaseApiResponse, LookupItem, MappedLookupItem } from "common/types";
import dayjs from "dayjs";
import { Instance, StartInstanceRequest } from "./types";
import { mapLookup } from "common/helpers";

export const fetchInstances = createAsyncThunk<{ data: Instance[]; total: number; }, void>(
    'instanceMgr/fetchInstances',
    async () => {
        const { data } = await wrapRequest<BaseApiResponse<Instance[]>>({
            handler: () => service.getInstances(),
            showNotifications: true
        });

        const mappedData = {
            data: data?.result.map(i => ({
                ...i,
                key: i.instanceId,
                launchTime: i.launchTime && dayjs.utc(i.launchTime).format("MM-DD-YYYY HH:mm"),
            })) || [],
            total: data?.result.length || 0,
        };

        return mappedData;
    }
);

export const fetchProjects = createAsyncThunk<{ data: MappedLookupItem[] }, void>(
    'instanceMgr/fetchProjects',
    async () => {
        const { data } = await wrapRequest<BaseApiResponse<LookupItem[]>>({
            handler: () => service.getProjects(),
            showNotifications: true
        });

        const mappedData = {
            data: data?.result.map(mapLookup) || []
        };

        return mappedData;
    }
);

export const startInstance = createAsyncThunk<void, StartInstanceRequest>(
    'instanceMgr/startInstance',
    async (request, { rejectWithValue }) => {
        const err = await wrapRequest<void>({
            handler: () => service.startInstance(request),
            showNotifications: true
        });

        if (err.errors?.length || err.warnings?.length) {
            return rejectWithValue(err);
        }
    }
);

export const stopInstance = createAsyncThunk<void, StartInstanceRequest>(
    'instanceMgr/stopInstance',
    async (request, { rejectWithValue }) => {
        const err = await wrapRequest<void>({
            handler: () => service.stopInstance(request),
            showNotifications: true
        });

        if (err.errors?.length || err.warnings?.length) {
            return rejectWithValue(err);
        }
    }
);